/**
 * @class
 * @property {number} id
 * @property {string} text - русскоязычное название региона
 * @property {?number} parentId - родительский регион
 * @property {?number} mainTownId - столица области (если выбрана область)

 * @property {number} lat - широта
 * @property {number} lng - долгота
 * @property {?object} bounded_by - границы региона для ограничения гео-поиска
 * @property {{lat: number, lng: number}} bounded_by.lowerCorner
 * @property {{lat: number, lng: number}} bounded_by.upperCorner

 * @property {boolean} hasDistricts - в регионе есть районы
 * @property {boolean} hasHighway - в регионе есть шоссе
 * @property {boolean} hasMetro - в регионе есть метро
 */
export default class Region {
  constructor({
    id,
    text,
    displayName,
    parentId,
    mainTownId,
    lat,
    lng,
    bounded_by,
    boundedBy,
    hasDistricts,
    hasHighway,
    hasMetro,
  }) {
    this.id = id;
    this.parentId = parentId;
    this.mainTownId = mainTownId;
    this.lat = lat;
    this.lng = lng;
    this.hasDistricts = hasDistricts;
    this.hasHighway = hasHighway;
    this.hasMetro = hasMetro;
    // От разных API могут приходить по-разному
    this.bounded_by = bounded_by || boundedBy;
    this.text = text || displayName;
  }

  /**
   * @return {boolean}
   */
  isCity() {
    return !!this.parentId;
  }
}


// WEBPACK FOOTER //
// ./src/serp/classes/Region.js